import ModernCompanyDetail from '../components/ModernCompanyDetail';

// /companies/:slug — one expanded detail for every brand (s153): the «Moderno»
// page approved in s140 (photo header, news, related insights, Next earnings
// above Follow), skinned per theme (lib/opportunitySkin).
export default function CompanyDetailPage() {
  return <ModernCompanyDetail />;
}
